import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import type {SelectMenuOption} from 'shells/action-menu/action-menu';
import {LegacySetupTableWrapper} from 'shells/table/legacy-setup-table-wrapper';

import type {EmailSequenceTemplateDuplicateInput} from 'nutshell-graphql-types';

import {getEmailSequenceTemplateFilters} from '../email-utils/get-email-sequence-template-filters';

import {useGetUncategorizedEmailTemplates} from './graphql/hooks';
import {TemplateTable} from './template-table';
import type {Template} from './types';

type Props = {
    icon: React.ComponentType<any>;
    actionMenuOptions?: SelectMenuOption[];
    templates: Template[];
    activeFilters: FilterObject[];
    onAddClick: () => void;
    onDeleteTemplate: (templateId: string, queryVariables: any) => Promise<any>;
    isLoading: boolean;
    errorMessage: string | null | undefined;
    setSequenceTemplateId: (arg1: string) => void;
    setSequenceTemplateName: (arg1: string) => void;
    setShouldShowModal: (arg1: boolean) => void;
    setShouldShowRenameModal: (arg1: boolean) => void;
    setShouldShowChangeGroupModal: (arg1: boolean) => void;
    setTemplateGroupId: (arg1: string) => void;
    onDuplicateTemplate: (arg1: EmailSequenceTemplateDuplicateInput) => Promise<any>;
    isDuplicating: boolean;
};

export function GroupTableUncategorized(props: Props) {
    const {creatorIds, onlyArchived, includeShared, search, includeUnsharedFromOthers} =
        getEmailSequenceTemplateFilters(props.activeFilters);

    const queryVariables = {
        creatorIds,
        search,
        onlyArchived,
        includeShared,
        includeUnsharedFromOthers,
    } as const;

    const {emailSequenceTemplates, isLoading: isFullFragmentLoading} =
        useGetUncategorizedEmailTemplates(queryVariables);

    const templates = emailSequenceTemplates.length ? emailSequenceTemplates : props.templates;

    return (
        <LegacySetupTableWrapper
            title='Uncategorized'
            count={templates.length}
            icon={props.icon}
            actionMenuOptions={props.actionMenuOptions}
        >
            <TemplateTable
                templates={templates}
                isLoading={props.isLoading}
                errorMessage={props.errorMessage}
                onAddRowClick={props.onAddClick}
                onDelete={(id: string) => props.onDeleteTemplate(id, queryVariables)}
                fullFragmentLoading={isFullFragmentLoading}
                setSequenceTemplateId={props.setSequenceTemplateId}
                setSequenceTemplateName={props.setSequenceTemplateName}
                setShouldShowModal={props.setShouldShowModal}
                setShouldShowRenameModal={props.setShouldShowRenameModal}
                setShouldShowChangeGroupModal={props.setShouldShowChangeGroupModal}
                setTemplateGroupId={props.setTemplateGroupId}
                onDuplicateTemplate={props.onDuplicateTemplate}
                // @ts-expect-error
                isDuplicating={props.isDuplicating}
            />
        </LegacySetupTableWrapper>
    );
}
